export type PdfExportQuality = 'standard' | 'high' | 'print';
export type ImageFitMode = 'fitPage' | 'fitWidth' | 'original';

export interface PdfQualityLayout {
  margin: number;
  footerReserved: number;
  bodySize: number;
  subjectSize: number;
  sectionTitleSize: number;
  metaSize: number;
  lineHeightMult: number;
  /** html2canvas scale when raster fallback is used (~2–3.5). */
  rasterScale: number;
}

const LAYOUTS: Record<PdfExportQuality, PdfQualityLayout> = {
  standard: {
    margin: 44,
    footerReserved: 38,
    bodySize: 10,
    subjectSize: 17,
    sectionTitleSize: 11,
    metaSize: 9.5,
    lineHeightMult: 1.38,
    rasterScale: 2,
  },
  high: {
    margin: 50,
    footerReserved: 42,
    bodySize: 10.5,
    subjectSize: 18,
    sectionTitleSize: 11.5,
    metaSize: 10,
    lineHeightMult: 1.44,
    rasterScale: 2.85,
  },
  print: {
    margin: 56,
    footerReserved: 46,
    bodySize: 11,
    subjectSize: 19,
    sectionTitleSize: 12,
    metaSize: 10.5,
    lineHeightMult: 1.5,
    rasterScale: 3.35,
  },
};

export function layoutForQuality(q: PdfExportQuality | undefined): PdfQualityLayout {
  return LAYOUTS[q ?? 'print'];
}
